<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils';

export interface DialogFooterProps {
	class?: HTMLAttributes['class'];
}

const props = defineProps<DialogFooterProps>();
</script>

<template>
	<div
		:class="
			cn(
				'flex items-center justify-between border-t border-white-dark-3 px-5 py-3 lg:py-4',
				props.class
			)
		"
	>
		<slot></slot>
	</div>
</template>
